import { Observable } from "rxjs";
import { AbstractScreenHandler, CRUDGenericService, TypeValidatorService } from 'attcei-bo-fw';
import { ScreenHandler } from 'attcei-bo-fw/lib/screen/interfaces/ScreenHandler';
import { Injectable } from '@angular/core';
import { PaginationState } from 'attcei-bo-fw/lib/classes/PaginationState';
import { Sort } from '@angular/material/sort';
import { PaginatedDTO } from 'attcei-bo-fw/lib/classes/dto/PaginatedDTO';
import { CollectionRecordDTO } from "../classes/dto/CollectionRecordDTO";

@Injectable({
    providedIn:'root'
})
export class CollectionRecordScreenHandler extends AbstractScreenHandler<CollectionRecordDTO, CollectionRecordDTO> implements ScreenHandler<CollectionRecordDTO, CollectionRecordDTO>{
    constructor(private service: CRUDGenericService, typeValidator: TypeValidatorService){
        super(typeValidator);
    }
    
    loadListData(filter: any, paginationState: PaginationState, sort: Sort): Observable<PaginatedDTO<CollectionRecordDTO>> {
        var url:string = this.getURL() + this.buildInvocationWithPaginationAndFilter(paginationState, filter, sort);
        return this.service.getDataList(url, true);
    }

    post(item: CollectionRecordDTO):Observable<CollectionRecordDTO> {
        console.log("Recebi no post -> ", item);
        var dto: CollectionRecordDTO = super.parse(item);
        var res: Observable<CollectionRecordDTO> = this.service.postData(this.getURL(),dto,true);
        console.log("result -> ", res);
        return res;
    }

    update(item: CollectionRecordDTO):Observable<CollectionRecordDTO> {
        console.log("Recebi no update -> ", item);
        var dto: CollectionRecordDTO = super.parse(item);
        var res: Observable<CollectionRecordDTO> = this.service.putData(this.getURL(), dto.id, dto, true);
        console.log("parsed -> ", res);
        return res;
    }

    delete(item: any):Observable<CollectionRecordDTO> {
        return this.service.delete(this.getURL(), item.id, true);
    }

    getItem(id: number):Observable<CollectionRecordDTO> {
        return this.service.getDataItem(this.getURL(), true, id);
    }

    getURL(): string {
        return "collectionrecord"
    }

    getId(item: CollectionRecordDTO): number {
        return item.id;
    }
    
    protected getUpdateTypeName(): string {
        return "CollectionRecordDTO";
   
    }    
    
    protected getCreateTypeName(): string {
        return "CollectionRecordDTO";
    }
}